import React from 'react';
import cn from 'classnames';
import BookDemoButton from '@/dataroom/ui/common/BookDemoButton';
import baseStyles from '@/dataroom/ui/components/Landing/researchRoom/tenantResearchRoomStyles.module.scss';
import styles from './startActions.module.scss';
import GetStartedButton from '@/dataroom/ui/components/Landing/common/GetStartedButton';

const StartActions = () => (
  <div className={ styles.actionsWrp }>
    <BookDemoButton className={ cn(baseStyles.actionButton, styles.bookDemoButton) } />
    <GetStartedButton className={ cn(baseStyles.actionButton, styles.getStartedButton) } />
  </div>
);

export default StartActions;
